import { ROUTE_PARAMS } from 'constants/routeParamNames';

import { ROUTES_BANK_ROOT, ROUTES_ROOT } from './routesRoot';

// роуты со старого фронта (репозиторий creditselection-frontend)
export const OLD_WEB_ROUTES = {
  // старые WL страницы (должны вести на ту же страницу, что и /kredity/onlajn-zayavka-na-kredit/wl)
  oldWhiteLabel: `${ROUTES_ROOT}/onlajn-zayavka-na-kredit/whitelable`,
  oldWhiteLabelAgents: `${ROUTES_ROOT}/onlajn-zayavka-na-kredit/wl/agents`,

  // старые WL кредитных карт (должен вести на ту же страницу, что и /kredity/promo/karty)
  oldCreditCardsWhiteLabel: `${ROUTES_ROOT}/promo/karty/wl`,

  // старые страницы (должны вести на ту же страницу, что и /kredity/podbor-onlajn/)
  oldPromo: `${ROUTES_ROOT}/promo`,
  oldSend: `${ROUTES_ROOT}/send`,
  oldKreditOnlajn: `${ROUTES_ROOT}/kredit-onlajn`,
  oldKartyOnlajn: `${ROUTES_ROOT}/karty-onlajn`,
  oldOnlajnZayavkaNaKredit: `${ROUTES_ROOT}/onlajn-zayavka-na-kredit`,
  oldPodborOnlajnV3: `${ROUTES_ROOT}/podbor-onlajn-v3`,
  // с auth -> на ту же страницу, что и /kredity/podbor-onlajn/ без auth -> на ту же страницу, что и /kredity/onlajn/
  oldBankOnlajnZayavkaNaKredit: `${ROUTES_BANK_ROOT}/:${ROUTE_PARAMS.BANK_ALIAS}/kredity/onlajn-zayavka-na-kredit`,

  // SEO страницы
  // (должна вести на ту же страницу, что и /kredity/promo/karty)
  seoKartyOnlajn: `${ROUTES_ROOT}/karty-onlajn/region/:${ROUTE_PARAMS.REGION_ALIAS}`,
  // (должна вести на ту же страницу, что и /kredity/onlajn)
  seoKreditOnlajn: `${ROUTES_ROOT}/kredit-onlajn/region/:${ROUTE_PARAMS.REGION_ALIAS}`,
} as const;
